var platformEnv = process.env.VUE_APP_PLATFORM;
export default {
  name: 'Detail',
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    replaceContent: function replaceContent() {
      if (!this.detail.content) return '';
      return this.detail.content.replace(/\[平台名称\]/g, platformEnv === 'demi' ? '德米' : platformEnv === 'qyzy' ? '青云智业' : '青云端');
    }
  },
  methods: {
    cancel: function cancel() {
      localStorage.setItem('readNotice', true);
      this.$emit('change', false);
    }
  }
};